import { toast } from 'react-toastify';
import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Link } from 'react-router-dom';
import z from "zod";
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from "react-hook-form";

import "./forgotPassword.css";
import { ROUTES, MESSAGE } from '../../../constant';
import BaseNavbar from '../../commanComponents/navbar/baseNavbar';
import { forgotPasswordService } from "../../../modules/services";
import TextInputField from '../../commanComponents/textInputField/textInputField';
import PrimaryButton from '../../commanComponents/primaryButton/primaryButton';
import TurnstileWidget from '../../commanComponents/turnstileWidget/turnstileWidget';


const ForgotPassword = () => {
    
    const [isLoading, setIsLoading] = useState(false);
    const [captchaToken, setCaptchaToken] = useState(null);
    const [captchaResetKey, setCaptchaResetKey] = useState(0);
    
    const loginSchema = z.object({
        email: z.string().min(1, { message: MESSAGE.REQUEIRED_THIS_FIELD.replace("{0}", "Email")}).email({message: MESSAGE.EMAIL_INVALID}),
        role: z.string().default("USER")
    });
    const { register, handleSubmit, setError, reset, formState: { errors } } = useForm({
        resolver: zodResolver(loginSchema)
    });


    const handleForgotPassword = (data) => {
        if (!captchaToken) {
            toast.error("Please complete the verification and try again.");
            return;
        }
        setIsLoading(true);

        forgotPasswordService({ ...data, captcha_token: captchaToken }, {}).then(apiResponse => {
            toast.success(apiResponse.data.message[0], {
                position: toast.POSITION.TOP_RIGHT,
            });
            setIsLoading(false);
            reset();
        }).catch(error => { 
            setIsLoading(false);
            if (error.response.data.error === "email") {
                setError("email", {type: "custom", message: error.response.data.message[0]})
            }
            else {
                toast.error(error.response.data?.message[0], {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        }).finally(() => {
            setCaptchaToken(null);
            setCaptchaResetKey((key) => key + 1);
        });
    }

    return (
        <>
            <BaseNavbar />
            <div className='forgot-main-div'>
                <div className='forgot-form-div'>
                    <Form onSubmit={handleSubmit(handleForgotPassword)}>
                        <Form.Label className='forgot-heading'>
                            Forgot Password
                        </Form.Label>
                        <Form.Label className='forgot-sub-heading'>
                            hope you will find your credentials!
                        </Form.Label>

                        <TextInputField
                            iconClass="bi-envelope-fill"
                            placeholder="Email"
                            fieldType="email"
                            errorMessage={errors.email?.message}
                            inputKey="email"
                            formRegister={register}
                        />
                        <TurnstileWidget key={captchaResetKey} action="forgot_password" onToken={setCaptchaToken} />
                        <br />

                        <div className='forgot-submit-button-div'>
                            <PrimaryButton
                                text="SUBMIT"
                                type={"submit"}
                                isLoading={isLoading}
                                onlyDisabled={isLoading || !captchaToken}
                                customStyle={{height: "40px"}}
                            />
                            <br />
                            <br />
                            <Link to={ROUTES.LOGIN} className='forgot-back-to-login'>
                                <u>Back to Login</u>
                            </Link>
                        </div>
                    </Form>
                </div>
            </div>
        </>
    );
}

export default ForgotPassword;
